/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { humanize } from "uno-js";
import { toast } from "react-hot-toast";
import { UPLOAD_CSV } from "../pages/DoftStatement/graphql/upload-csv.mutation";
import {GET_STATEMENT_TABLE} from "../pages/DoftStatement/graphql/statement-table.query";
import { string } from "yup";

const MODULE_NAME = "DoftStatementService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export class DoftStatementService {
    private static instance: DoftStatementService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL;
    }
    public static getInstance(props: any = {}): DoftStatementService {
        if (!DoftStatementService.instance) {
            DoftStatementService.instance =
                new DoftStatementService(props);
        }
        return DoftStatementService.instance;
    }

    async uploadCSV(data: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        log.blue(MODULE_NAME, `upload csv data in service`, data);
        
        try {
            if (client) {
                const res = await client.mutate({
                    mutation: UPLOAD_CSV,
                    variables:{...data},
                    fetchPolicy: "no-cache",
                });
                if (res) {
                    return res;
                }
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async getDoftStatementTable(limit: number, skip: number, filter: any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_STATEMENT_TABLE,
                    variables: {
                        criteria: filter,
                        skip: skip,
                        limit: limit
                    },
                    fetchPolicy: "network-only",
                });
                if (res?.data?.getBankstatementTable)
                    return res?.data?.getBankstatementTable;
            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
